 @if (booking?.Status == 0 || booking?.Status == 50) {
 @if (toFarAway) {
 @if (booking) {
<h1>{{ booking.PickupLocation.Name }}</h1>
 }
<div #gmap id="map"></div>
 } @else {
 @if (booking) {
<h1>
  {{ 'Intellitrailer.Booking.Components.BookingSummary.Trailer' | translate : 'Trailer' }}:
  @if(booking.IsOneWay){
  {{ booking.RentalObject?.Alias ?? booking.RentalObject?.Title }}
  }
  @else{
  {{ booking.RentalObject?.Title ?? '---' }}
  }
</h1>
<img src="{{ booking.PrimaryType.PictureUri }}" />
<h2><strong>{{ 'Intellitrailer.Booking.Components.BookingSummary.RentalTimes' | translate : 'Rent times' }}</strong></h2>
<div class="row">
  <div class="col-4">
    <small><strong>{{ 'turbo.core.RentalDialog.Pickup' | translate : 'Pickup' }}</strong></small>
    <p>{{ booking.PickupTime | date : 'd MMM' }} {{ booking.PickupTime | date : 'HH:mm' }}</p>
  </div>
  <div class="col-4">
    <mat-icon>arrow_right_alt</mat-icon>
  </div>
  <div class="col-4">
    <small><strong>{{ 'turbo.core.RentalDialog.Return' | translate : 'Return' }}</strong></small>
    <p>{{ booking.ReturnTime | date : 'd MMM' }} {{ booking.ReturnTime | date : 'HH:mm' }}</p>
  </div>
</div>
<h2>{{ 'Intellitrailer.Booking.Components.BookingSummary.RentalLocation' | translate : 'Rental location' }}</h2>
<p>{{ booking.PickupLocation.Name }}</p>
 }
 }

@if (appService.Device.Location < 3 && !toEarly) {
<p id="text-red">
  {{'Intellitrailer.AllowLocationAccessInfo.NolocationAccessText' | translate : 'You have not provided access to your devices location. We cannot determine that you are in the correct place to pickup your trailer.'}}
</p>
<!-- Always allow starting rent even without GPS -->
<button (click)="sendRentalAction('start')" mat-raised-button color="primary">
  {{ 'Intellitrailer.Rental.Components.RentalBox.StartRent' | translate : 'Start rent' }}
</button>
}
@else {
@if (toFarAway) {
<p id="text-red"><strong>{{'Intellitrailer.Rental.BookingInfo.GoToLocationPrompt' | translate : 'Go to {0} to start your rent' : [booking.PickupLocation?.Name] }}</strong></p>
     }
  @else if (toEarly) {
<p id="text-red">
  <strong>{{'Intellitrailer.Rental.BookingInfo.ReadyForPickup' | translate : 'Ready for pickup' }} {{ pCountdown.locale(appSettings.getLanguage()).humanize(true) }}</strong>
</p>
  @if (available && !toFarAway) {
<button (click)="pickupNow()" mat-raised-button color="primary">
  {{ 'Intellitrailer.Booking.Components.BookingSummary.StartNow' | translate : 'Start Now' }}
</button>
   }
 }
 @else {
   @if (!toFarAway) {
     @if (allowUnmanned) {
<button (click)="sendRentalAction('start')" mat-raised-button color="primary">
  {{ 'Intellitrailer.Rental.Components.RentalBox.StartRent' | translate : 'Start rent' }}
</button>
     }
     @else {
       @if (!isElecticBike) {
<p id="text-red">
  {{'Intellitrailer.Rental.BookingInfo.EnterStoreInfo' | translate : 'Enter the store to sign the rental contract and get access to keys to the vehicle'}}
</p>
        }
        @else {
<p id="text-red">
  {{
'Intellitrailer.Rental.BookingInfo.EnterStoreInfoBike' | translate : 'Enter the store and talk to the personnel to start the rent and get access to the keys, helmet and battery for the bike'
  }}
</p>
        }
      }
   }
 }
}

<button id="cancel" (click)="sendRentalAction('cancelBooking')" mat-button>
  {{ 'Intellitrailer.MyPage.BookingOverview.CancelBooking' | translate : 'Cancel booking' }}
</button>
 }

 @if (booking?.Status == 100 || booking?.Status == 150) {
 @if (booking) {
<h1>
  {{ 'Intellitrailer.Booking.Components.BookingSummary.Trailer' | translate : 'Trailer'}}:
  {{ booking.RentalObject?.Title }}
</h1>
<img src="{{ booking.PrimaryType.PictureUri }}" />
 }

<h2><strong>{{ 'Intellitrailer.Rental.Components.RentalBox.ReturnTo' | translate : 'Return to' }}</strong></h2>
<p>
  {{ booking.ReturnLocation.Name }}<br />
  {{ booking.ReturnLocation.Address }}
</p>

 @if (!late) {
<h2><strong>{{ 'Intellitrailer.Rental.InFlight.TimeLeft' | translate : 'TimeLeft' }}</strong></h2>
 } @else {
<p id="text-red">
  <strong>{{ 'Intellitrailer.Rental.InFlight.Delayed' | translate : 'Delayed' }}</strong>
</p>
  }
<p id="text-red">
  {{ rCountdown?.locale(Settings.clientSettings.Language).humanize() }}
  ({{ booking.ReturnTime | date : 'd MMM' }} {{ booking.ReturnTime | date : 'HH:mm' }})
</p>

 @if (late) {
<p id="text-red-small">
  <strong>{{ 'Intellitrailer.Rental.InFlight.msgLateExtensions' | translate : 'Extension is not allowed due to delayed booking' }}</strong>
</p>
 }
@else if (isVarebil) {
<p id="text-red-small">
  <strong>{{ 'Intellitrailer.Rental.InFlight.msgLateExtensionVarebil' | translate : 'Extension is not allowed for Varebil rentals' }}</strong>
</p>
}

<div class="row justify-content-center">
  @if (hasLock) {
  <div class="col-6">
    <button id="cmdUnlock" (click)="sendRentalAction('unlock')" mat-raised-button color="primary">
      <mat-icon>lock_open</mat-icon>
    </button>
    <div>{{ 'Intellitrailer.Rental.InFlight.Unlock' | translate : 'Unlock' }}</div>
  </div>
  }
  <div class="col-6">
    <button id="cmdUnlock" [disabled]="late || isVarebil" (click)="sendRentalAction('extend')" mat-raised-button color="primary">
      <mat-icon>update</mat-icon>
    </button>
    <div>{{ 'Intellitrailer.Rental.InFlight.Extend' | translate : 'Extend' }}</div>
  </div>
</div>

<div>
  @if (!allowUnmanned && !isElecticBike) {
  <span>
    {{ 'Intellitrailer.Rental.BookingInfo.EnterStoreInfoReturn' | translate : 'Enter the store to complete the return process and return the keys to the vehicle' }}
  </span>
  } @else if (!allowUnmanned && isElecticBike) {
  <span>
    {{ 'Intellitrailer.Rental.BookingInfo.EnterStoreInfoReturnBike' | translate : 'Enter the store and return the keys, helmet and battery for the bike to complete the return process' }}
  </span>
  } <!--@else if (allowUnmanned) {
  <button (click)="sendRentalAction('return')" mat-raised-button>
    {{ 'Intellitrailer.Rental.InFlight.TerminateRent' | translate : 'Terminate rent' }}
  </button>
  }-->
</div>
  }
